<template>
  <b-overlay id="overlay-background" class="overlay-config calendar-seasonal" :show="loading" rounded="sm">
    <div class="calendar-title">
      <div>{{ $t('dom') }}</div>
      <div>{{ $t('seg') }}</div>
      <div>{{ $t('ter') }}</div>
      <div>{{ $t('qua') }}</div>
      <div>{{ $t('qui') }}</div>
      <div>{{ $t('sex') }}</div>
      <div>{{ $t('sab') }}</div>
    </div>
    <Calendar v-if="this.calendarData.Months && this.calendarData.Months.length > 0" :calendarData="this.calendarData" 
      :calendarName="seasonalCalendar.nameCalendar" @updateCalendarName="updateCalendarName"/>
  </b-overlay>
</template>

<script>
import axios from 'axios'
import SeasonalCalendarRepository from '../service/SeasonalCalendarRepository'
import { urlMainAPI, defaultSuccess } from '../../../global'
import moment from 'moment'
import { NumberFormat } from '../../flowchart/utils/tools'
import SeasonalCalendar from '../model/SeasonalCalendar'
import Calendar from './Calendar.vue'

export default {
  name: "CalendarSeasonal",
  components: { Calendar },
  props: ["saveData", "idCalendar", "callNewCalendar"],
  data() {
    return {
      seasonalCalendar: new SeasonalCalendar,
      weeks: 4,
      month: [{ weeks: [{ days: [] }] }],
      loading: false,
      numberFormat: NumberFormat,
      percentageAccumlated: 100,
      inputCalendar: false,
      currentDate: moment().format("YYYY-MM") + "-01",
      refreshTableCalendar: 0,
      backLastCalendar: 0,
      notUpdateCalendar: false,
      editNameCalendar: true,
      transientData: {},
      messageCalendar: "",
      lastName: "",
      sendSaved: -9999,
      calendarData:{},
      newName:"",
    }
  },

  watch: {
    loading(val){
      SeasonalCalendarRepository.fullLoading = val
    },
    
    saveData() {
      this.saveCalendar()
    },

    async idCalendar() {
      this.loadCalendarMonths(this.currentDate, this.idCalendar)
    },

    callNewCalendar() {
      this.inputCalendar = true;
    }
  },

  methods: {
    updateCalendarName(name){
      this.seasonalCalendar.nameCalendar = name;
    },

    async loadCalendarMonths(date,id){
      this.loading = true;
      SeasonalCalendarRepository.fullLoading = true;
      let url = `${urlMainAPI}/getseasonalcalendar/${date}/${id}`

      await axios.get(url).then(async res => {
        if (res.status == 200) {
          this.seasonalCalendar = res.data;
          if(res.data == null) {
            this.seasonalCalendar = SeasonalCalendarRepository.Get();
            this.seasonalCalendar.months = "";
            this.seasonalCalendar.revision =  new Date().toLocaleString("pt-BR").replace(",","");
            this.seasonalCalendar.nameCalendar = "Novo Calendário";
          }
          await this.setMonth();
          SeasonalCalendarRepository.updated = false;
        }
      }).catch(console.error)
      this.loading = false;
      SeasonalCalendarRepository.fullLoading = false;
    },

    async setMonth() {
      this.loading = true;
      // SeasonalCalendarRepository.fullLoading = true;
      if (!this.seasonalCalendar ) return;

      let months = this.seasonalCalendar.months ? JSON.parse(this.seasonalCalendar.months) : null;
      
      if(this.seasonalCalendar.months == "" || !this.seasonalCalendar.months || !this.seasonalCalendar.months.includes("Measurement")){
        this.calendarData = SeasonalCalendarRepository.GenerateFullCalendar()
      }else{
        this.calendarData = SeasonalCalendarRepository.GenerateFullCalendar(months)
      }
      this.loading = false;
    },

    async saveCalendar() {

      let sameName = SeasonalCalendarRepository.allCalendars.filter(item => item.nameCalendar == this.seasonalCalendar.nameCalendar && item.id != this.seasonalCalendar.id)
      if(sameName.length > 0){
        this.$bvToast.toast(`Já existe um calendário com o nome ${this.seasonalCalendar.nameCalendar}. Por favor, altere o nome e tente novamente.`, {
          title: `Calendário ${this.seasonalCalendar.nameCalendar} já existe.`,
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      this.loading = true;
      let monthsToSave = this.calendarData.Months.filter(item => 
        item.SeasonalDays.filter(day => day.DateValue != "0" && day.DateValue > 0).length > 0
      )

      let objToSave = {
        Year: new Date().getFullYear().toString(),
        Measurement: "",
        Months: monthsToSave
      }
      
      if(SeasonalCalendarRepository.indicatorsRelated.length > 0){
        let foundRelated = SeasonalCalendarRepository.indicatorsRelated.filter(item => item.calendarId == this.seasonalCalendar.id);

        if(foundRelated.length > 0){
          let unit = foundRelated[0].indicatorName.match(/\(([^)]+)\)/g);

          if(unit){
            let measurement = unit[unit.length - 1].slice(1, -1);

            objToSave.Measurement = measurement.trim();
          }
        }
      }

      this.seasonalCalendar.months = JSON.stringify(objToSave)
      this.seasonalCalendar.revision = new Date().toLocaleString("pt-BR").replace(",","");
      await axios.post(`${urlMainAPI}/saveseasonalcalendarlist`, this.seasonalCalendar)
        .then(async res => {
          if (res.status == 200) {
            defaultSuccess(res.data);
            this.saveInSessionOrReload()
          }
        })
      this.inputCalendar = false;
      this.$emit("saved", this.sendSaved++)
      this.$emit("refreshTableCalendar", ++this.refreshTableCalendar)

      await this.loadCalendarMonths(this.currentDate, this.seasonalCalendar.id)
      this.loading = false;
    },

    saveInSessionOrReload() {
      if (this.idCalendar) {
        SeasonalCalendarRepository.Save(this.seasonalCalendar);
        SeasonalCalendarRepository.updated = false
      }
      else {
        setTimeout(() => {
          this.$emit("selectNameCalendar", this.seasonalCalendar.nameCalendar)
        }, 300)
      }
    },

    tryGetCalendarInStorage() {
      this.seasonalCalendar = SeasonalCalendarRepository.Get();
      if (this.seasonalCalendar) {
        this.setMonth();
        this.loading = false;
      }
    }
  },

  async mounted() {
    this.loading = true;
    this.tryGetCalendarInStorage()
    this.loading = false;
  },
}
</script>


<style scoped>
.calendar-seasonal {
  display: grid;
  grid-template-rows: 7% 84% 8%;
  background: #009A9850;
  border-radius: 5px;
  overflow-y: auto;
  box-shadow: 0 0 2px #0005;
}

.calendar-body {
  display: grid;
}

.calendar-week,
.calendar-title {
  display: flex;
}

.calendar-week>div,
.calendar-title>div {
  padding-right: 4px;
  width: 100%;
}

.calendar-title>div {
  font-weight: 500;
  font-size: 1.3rem;
  background: #FF8E3C;
  color: #fff;
  text-align: center;
}

.calendar-title>div:last-child {
  border-top-right-radius: 5px;
}

.calendar-title>div:first-child {
  border-top-left-radius: 5px;
}

.calendar-week>div:last-child,
.calendar-title>div:last-child {
  padding-right: 0;
}

.zebra-line {
  background-color: #009A9830;
}

.calendar-config {
  display: flex;
  align-content: center;
  align-items: center;
  font-size: 1.3rem;
}

.seasonal-name {
  display: flex;
  min-width: 300px;
  font-size: 1.1rem;
}

.align-div-accumulated {
  text-align: end;
  min-width: 300px;
}

.number-lower {
  color: #f00;
  font-weight: 500;
}

.number-upper {
  color: #0b0;
  font-weight: 500;
}

.editable {
  cursor: pointer;
}
</style>